export default __webpack_public_path__ + "static/media/map-bear.221b91bd.svg";